import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ p: { lg: '60px 0 70px 0px' }, background: '#D2B48C' }}>
      <hr />
      <Typography
        sx={{
          fontFamily: 'Chewy',
          fontWeight: 500,
          fontSize: '40px',
          textAlign: 'center',
          color: '#5F3A19 ',
        }}
      >
        Contact Us
      </Typography>
    </Box>
  );
};

export default Footer;
